<template>
    <v-layout row>
        <v-select :items="roles" v-model="selectedRole" clearable label="Role" solo flat single-line :disabled="this.disabled"></v-select>
        <v-select v-model="selectedYear" clearable label="Year" :items="years" solo flat single-line v-show="!disableYearCohort" ref="vs-Year" :disabled="this.disabled"></v-select>
        <v-select v-model="selectedCohort" clearable label="Cohort" :items="cohorts" solo flat single-line v-show="!disableYearCohort" ref="vs-Cohort" :disabled="this.disabled"></v-select>
    </v-layout>
</template>

<script>
import { getYearsAndCohorts, initialize } from '../utils/effort-tracking-api';
import { globalStore } from '../main';

export default {
    name: 'status-filters',
    props: ['disabled'],
    data () {
        return {
            years: [],
            selectedYear: 'undefined',
            roles: [],
            cohorts: [],
            selectedRole: 'undefined',
            selectedCohort: 'undefined',
            disableYearCohort: false
        }
    },
    watch: {
        selectedYear: {
            handler() {
                    this.$emit('filter-selected', this.selectedRole, this.selectedYear, this.selectedCohort);
            }
        },
        selectedRole: {
            handler() {
                if (this.selectedRole != "Teacher")
                {
                    this.disableYearCohort = false;
                    this.$emit('filter-selected', this.selectedRole, this.selectedYear, this.selectedCohort);
                }
                else
                {
                    this.disableYearCohort = true;
                    this.$emit('filter-selected', this.selectedRole, 'undefined', 'undefined');
                }
            }
        },
        selectedCohort: {
            handler() {
                    this.$emit('filter-selected', this.selectedRole, this.selectedYear, this.selectedCohort)
            }
         }
    },

    mounted() {
        initialize().then(x => {
            getYearsAndCohorts(globalStore.selectedPeriod).then( result => {
                if (result.years != '') {
                    result.years.forEach( year => { this.years.push(year.name) });

                    result.cohorts.forEach(cohort => { this.cohorts.push(cohort.name) });
                }
            }).catch( ex => console.log(ex) );

            this.roles.push('Student','Teacher');
        });
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/StatusFilters.vue